import { boolean, defineAction, enumerated, object, string } from '~/prix'
import monitorProductMetricIdsImport from './monitorProductMetricIdsImport.action.json'
import monitorProductMetricIdsImportEntity from './monitorProductMetricIdsImport.entity'

const monitorProductMetricIdsImportDefinition = defineAction({
  ...monitorProductMetricIdsImport,
  input: object({
    file: string().isOptional(),
    step: enumerated({
      fetchUploadUrl: 'fetchUploadUrl',
      importFile: 'importFile',
    }),
    contentType: string().isOptional(),
  }),
  output: object({
    success: boolean(),
    item: monitorProductMetricIdsImportEntity.schema.isOptional(),
  }),
})

export default monitorProductMetricIdsImportDefinition
